import React, { ReactElement } from "react";

export function DraggableHandle(): ReactElement {
  return (
    <div className="h-4 w-4 rounded-sm border border-companyDarkGrey bg-white" />
  );
}
